class ScrollService {
  public snackbar?: any = undefined
  constructor() {}

  public scrollTo(id: string, options: ScrollIntoViewOptions = { behavior: 'smooth' }): void {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView(options)
    }
  }
}
export default new ScrollService()
